import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import settings from './settings';

// if (!Vue.config.errorHandler && process.env.NODE_ENV !== 'production') {
if (!Vue.config.errorHandler) {
    Vue.config.errorHandler = function (err, vm, info) {
        console.error(err); // eslint-disable-line no-console
    };
}

Sentry.init({
    dsn: settings.sentry,
    integrations: [new Sentry.Integrations.Vue({ Vue })],
    release: process.env.GIT_REVISION,
    tags: {
        git_commit: process.env.GIT_REVISION
    }
});
